import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { media } from 'styled-bootstrap-grid';
import { useTranslations } from '@lang';

export const StyledRequired = styled.span`
  font-style: italic;
  opacity: 0.5;
  flex-shrink: 0;
  min-width: 50px;
  max-width: ${({ width }) => width};
  width: 100%;
  text-align: right;
  line-height: 24px;

  ${({ desktopOnly }) =>
    desktopOnly &&
    css`
      display: none;

      ${media.lg`
      display: block;
      padding: 0 0 0 10px;
      text-align: left;
    `}
    `};

  ${({ mobileOnly }) =>
    mobileOnly &&
    css`
      display: block;

      ${media.lg`
      display: none;
    `}
    `};
`;

const RequiredIndicator = ({
  isRequired = false,
  desktopOnly = false,
  mobileOnly = false,
  requiredLabelWidth,
}) => {
  const { t } = useTranslations();

  return requiredLabelWidth ? (
    <StyledRequired desktopOnly={desktopOnly} mobileOnly={mobileOnly} width={requiredLabelWidth}>
      {isRequired && t('app.requiredField')}
    </StyledRequired>
  ) : null;
};

RequiredIndicator.propTypes = {
  isRequired: PropTypes.bool,
  desktopOnly: PropTypes.bool,
  mobileOnly: PropTypes.bool,
  requiredLabelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
};

export default RequiredIndicator;
